module.exports = __webpack_public_path__ + "img/genswell_3_2.3c44bdf5.png";